"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const userTelemetry_1 = require("../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'authentication',
    props: {},
    computed: {
        authenticatedModel() {
            return this.$store.getters.authenticatedModel;
        },
        isSyncing() {
            return this.$store.getters.isSyncing;
        },
        currentChallengeType() {
            return this.$store.getters.currentChallengeType;
        },
    },
    watch: {
        authenticatedModel(newAuthenticatedModel) {
            if (newAuthenticatedModel && typeof newAuthenticatedModel.username == 'string' && typeof newAuthenticatedModel.nonce == 'string') {
                this.$nextTick(() => {
                    const formElement = document.querySelector('#form_authenticated');
                    if (formElement) {
                        this.$store.commit('setIsSubmittingAuthenticatedModel', true);
                        formElement.submit();
                    }
                });
            }
        },
        async isSyncing() {
            while (this.$store.getters.isSyncing && !this.authenticatedModel.username.length) {
                const challenge = {
                    ...this.$store.getters.checkSyncResultChallenge,
                };
                await this.$store.dispatch('submitChallenge', challenge);
                await new Promise((r) => setTimeout(r, 1000));
            }
        },
    },
    components: {},
    async mounted() {
        var _a;
        void userTelemetry_1.telemetry.page(userTelemetry_1.workflowName.retail_registration);
        if (((_a = this.$store.getters.configuration.loginCredentials) === null || _a === void 0 ? void 0 : _a.UserName) === '') {
            await this.$store.dispatch('getRememberedUsername');
        }
        this.$store.commit('currentChallenge', {
            ChallengeTypeValue: this.$store.getters.configuration.initialChallengeType,
            Progression: [],
        });
    },
});
